<div class="modal-header">
  <div class="font-xl fw-bold text-center">
    <span [translate]="'modal.chooseAddressToDeliver.header'"></span>
    <i class="icon-close" (click)="modal.dismiss()"></i>
  </div>
</div>
<div class="modal-body">
  <div class="custom-accordion bottom-space">
    <div ngbAccordion #acc="ngbAccordion" [closeOthers]="true">
      <div ngbAccordionItem *ngFor="let address of deliveryAddresses"
           (shown)="onAddressOpened(address.id)">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>
          <div class="row title">
            <div class="col-6 text-truncate pe-3">{{address.address}}</div>
            <div class="col-6 text-truncate pe-3">{{address.postNumber}} {{address.cityName}}</div>
          </div>
          <i class="icon-chevron-down"></i>
          <i class="icon-chevron-up"></i>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
          <div class="mb-3" *ngIf="addressAvailabilityMap[address.id] === false">
            <ui-message
              [type]="'error'">
              <span [translate]="'modal.chooseAddressToDeliver.bakeryCantDeliverError'">
                Bakery can't deliver to that address, please try another one
              </span>
            </ui-message>
          </div>
          <div class="row">
            <div class="col-sm-6 font-sm">
              <div>
                <div class="fw-bold" [translate]="'orderProcess.delivery.deliveryForms.recipientName'">Recipient's
                  name
                </div>
                <div>{{address.recipient}}</div>
              </div>
            </div>
            <div class="col-sm-6 mt-xs-max-3 font-sm">
              <div>
                <div class="fw-bold"
                     [translate]="'orderProcess.delivery.deliveryForms.recipientPhone'">Contact
                  phone
                </div>
                <div>{{address.phone}}</div>
              </div>
            </div>
            <div class="col-sm-6 font-sm">
              <div class="mt-3" *ngIf="address.note">
                <div class="fw-bold"
                     [translate]="'modal.chooseAddressToDeliver.messageToDriver'">
                  Information for driver
                </div>
                <div>{{address.note}}</div>
              </div>
            </div>
            <div class="col-sm-6 font-sm">
              <div class="row mt-3">
                <div class="col-sm-8">
                  <button class="btn btn-pink w-100"
                          [disabled]="!addressAvailabilityMap[address.id]"
                          (click)="modal.close(address)"
                          [translate]="'modal.chooseAddressToDeliver.select'">Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
